import getIsLoyaltyEnabled from './getIsLoyaltyEnabled'

function getHasLoyaltyAccount(state: App.State): boolean {
  return !!(getIsLoyaltyEnabled(state) && state.loyalty.account.data)
}

export default getHasLoyaltyAccount
